module.exports = __webpack_public_path__ + "c08e97710bf8b56213d833db171c176f.svg";